export default __webpack_public_path__ + "static/media/EagleViewLogoWithText.46072fc2.svg";